import {call, put, takeLatest, select} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import {isEmpty} from '../helpers/general.helper';
import { push } from 'connected-react-router'
import {EDIT_PROFILE_ROUTE} from '../config/routes';
import {GENERIC_ERROR_MESSAGE} from "../config/messages";
import {
    GET_SAVED_NEWS, 
    GET_FAVORITE_CINEMAS, 
    GET_YOUR_RETINGS, 
    GET_FAVORITE_MOVIES, 
    GET_UNVIEWED_NOTIFICATION_COUNT, 
    GET_USER_DETAILS,
    GET_NOTIFICATION_LIST,
    READ_NOTIFICATION,
    DELETE_NOTIFICATION, 
    REMOVE_PROFILE_NEWS_FROM_FAVORITE,
    REMOVE_CINEMA_FROM_FAVORITE,
    GET_FAVORITE_MOVIES_SEE_MORE,
    GET_SAVED_NEWS_SEE_MORE,
    GET_FAVORITE_CINEMAS_SEE_MORE,
    REMOVE_PROFILE_MOVIE_FROM_FAVORITE,
    STORE_FACEBOOK_OR_GOOGLE_RESPONSE} from "../actions/types";
import {
    getSavedNews, 
    getSavedNewsSeeMore,
    getFavoriteCinemas, 
    getFavoriteCinemasSeeMore,
    getYourRatings, 
    getFavoriteMovies, 
    getFavoriteMoviesSeeMore,
    getUnviewedNotificationCount, 
    getUserDetails, 
    getNotificationList, 
    readNotification,
    deleteNotification,
    removeMovieFromFavorite,
    removeNewsFromFavorite,
    removeCinemaFromFavorite,
    getFavoriteMoviesAfterDelete,
    getFavoriteCinemasAfterDelete,
    getSavedNewsAfterDelete} from "../api/profile.api";
import {
    getSavedNewsSucceeded, 
    getSavedNewsSeeMoreSucceeded,
    getFavoriteCinemasSucceeded, 
    getFavoriteCinemasSeeMoreSucceeded,
    getYourRatingsSucceeded, 
    getFavoriteMoviesSucceeded, 
    getUnviewedNotificationsCountSucceeded, 
    getUserDetailsSucceeded, 
    getNotificationListSucceeded, 
    getFavoriteMoviesSeeMoreSucceeded,
    storeFacebookOrGoogleResponseSucceeded
} from "../actions/profile.actions";
import {showSpinner, hideSpinner} from "../actions/loading.actions"

function* getSavedNewsSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getSavedNews, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){   
            yield put(getSavedNewsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getSavedNewsSeeMoreSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getSavedNewsSeeMore, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){   
            const prevState = yield select(state => state.profile.savedNews);
            if (prevState.rows){
                const favNews = {...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager}
                yield put(getSavedNewsSeeMoreSucceeded(favNews));  
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getFavoriteCinemasSaga(action){
    try{  
        yield put(showSpinner());    
        const response = yield call(getFavoriteCinemas, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){     
            yield put(getFavoriteCinemasSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getFavoriteCinemasSeeMoreSaga(action){
    try{
        yield put(showSpinner()); 
        const response = yield call(getFavoriteCinemasSeeMore, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){
            const prevState = yield select(state => state.profile.favoriteCinemas)
            if(prevState.rows){
                const favCinemas = {...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager}
                yield put(getFavoriteCinemasSeeMoreSucceeded(favCinemas));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getYourRetingsSaga(action){
    try{
        yield put(showSpinner()); 
        const response = yield call(getYourRatings, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){
            yield put(getYourRatingsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getFavoriteMoviesSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getFavoriteMovies, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){
            yield put(getFavoriteMoviesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getFavoriteMoviesSeeMoreSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getFavoriteMoviesSeeMore, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){
            const prevState = yield select(state => state.profile.favoriteMovies)
            if(prevState.rows){
                const favMovies = {...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager}
                yield put(getFavoriteMoviesSeeMoreSucceeded(favMovies));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getUnviewedNotificationsCountSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getUnviewedNotificationCount, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
            yield put(getUnviewedNotificationsCountSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getUserDetailsSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getUserDetails, action.payload);
        if(response.data === null) {
            yield put(hideSpinner());
            yield put(push(EDIT_PROFILE_ROUTE));
        }
        if (response.status === 200){
            yield put(hideSpinner());
            yield put(getUserDetailsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

function* getNotificationListSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getNotificationList, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
            yield put(getNotificationListSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* readNotificationSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(readNotification, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* deleteNotificaitonSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(deleteNotification, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            var notificationsResponse = yield call(getNotificationList, action.payload);
            if(notificationsResponse.status === 200){
                yield put(getNotificationListSucceeded(notificationsResponse.data));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.movieId);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            const prevState = yield select (state => state.profile.favoriteMovies);
            let rows = prevState.rows.filter(movie => {
                return movie.favorite_uuid !== action.payload.movieId
            });
            let favMoviesResponse = yield call(getFavoriteMoviesAfterDelete, {items_per_page: 3, page: action.payload.pager.current_page});
            let favMovie = []
            if(action.payload.pager.current_page > 0){
                if(favMoviesResponse.data.rows.length > 0){ 
                    const initialNumber = 3 * action.payload.pager.current_page;
                    const initialElements = prevState.rows.slice(0, initialNumber);
                    favMovie = initialElements.concat(favMoviesResponse.data.rows)
                } else {
                    favMovie = rows;
                }
            } else {
                favMovie = favMoviesResponse.data.rows
            }
     
            yield put(getFavoriteMoviesSucceeded({...prevState, rows: favMovie, pager: favMoviesResponse.data.pager}));      
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeNewsFromFavoriteSaga(action){
    try{
        yield put(showSpinner())
        const response = yield call(removeNewsFromFavorite, action.payload.newsId);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){             
            const prevState = yield select(state => state.profile.savedNews);
            let rows = prevState.rows.filter(news => {
                return news.favorite_uuid !== action.payload.newsId
            })
            let favNewsResponse = yield call(getSavedNewsAfterDelete, {items_per_page: 2, page: action.payload.pager.current_page});
            let favNews = []
            if(action.payload.pager.current_page > 0){
                if(favNewsResponse.data.rows.length > 0){ 
                    const initialNumber = 2 * action.payload.pager.current_page;
                    const initialElements = prevState.rows.slice(0, initialNumber);
                    favNews = initialElements.concat(favNewsResponse.data.rows)
                } else {
                    favNews = rows;
                }
            } else {
                favNews = favNewsResponse.data.rows
            }
            yield put(getSavedNewsSucceeded({...prevState, rows: favNews, pager: favNewsResponse.data.pager}));
        }
    }  catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeCinemaFromFavoriteSaga(action){
    try{
        yield put(showSpinner())
        const response = yield call(removeCinemaFromFavorite, action.payload.cinemaId);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            const prevState = yield select(state => state.profile.favoriteCinemas);
            let rows = prevState.rows.filter(cinema => {
                return cinema.favorite_uuid !== action.payload.cinemaId
            })
            let favCinemasResponse = yield call(getFavoriteCinemasAfterDelete, {items_per_page: 2, page: action.payload.pager.current_page});
            let favCinemas = []
            if(action.payload.pager.current_page > 0){
                if(favCinemasResponse.data.rows.length > 0){ 
                    const initialNumber = 2 * action.payload.pager.current_page;
                    const initialElements = prevState.rows.slice(0, initialNumber);
                    favCinemas = initialElements.concat(favCinemasResponse.data.rows)
                } else {
                    favCinemas = rows;
                }
            } else {
                favCinemas = favCinemasResponse.data.rows
            }
            
            yield put(getFavoriteCinemasSucceeded({...prevState, rows: favCinemas, pager: favCinemasResponse.data.pager}));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeFacebookOrGoogleResponseSaga(action){
    try{
        yield put(storeFacebookOrGoogleResponseSucceeded(action.payload));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    } 
}

export default function* profileSaga(){
    yield takeLatest(GET_SAVED_NEWS, getSavedNewsSaga);
    yield takeLatest(GET_SAVED_NEWS_SEE_MORE, getSavedNewsSeeMoreSaga);
    yield takeLatest(GET_FAVORITE_CINEMAS, getFavoriteCinemasSaga);
    yield takeLatest(GET_FAVORITE_CINEMAS_SEE_MORE, getFavoriteCinemasSeeMoreSaga);
    yield takeLatest(GET_YOUR_RETINGS, getYourRetingsSaga);
    yield takeLatest(GET_FAVORITE_MOVIES, getFavoriteMoviesSaga);
    yield takeLatest(GET_FAVORITE_MOVIES_SEE_MORE, getFavoriteMoviesSeeMoreSaga);
    yield takeLatest(GET_UNVIEWED_NOTIFICATION_COUNT, getUnviewedNotificationsCountSaga);
    yield takeLatest(GET_USER_DETAILS, getUserDetailsSaga);
    yield takeLatest(GET_NOTIFICATION_LIST, getNotificationListSaga);
    yield takeLatest(READ_NOTIFICATION, readNotificationSaga);
    yield takeLatest(DELETE_NOTIFICATION, deleteNotificaitonSaga);
    yield takeLatest(REMOVE_PROFILE_MOVIE_FROM_FAVORITE, removeMovieFromFavoriteSaga);
    yield takeLatest(REMOVE_PROFILE_NEWS_FROM_FAVORITE, removeNewsFromFavoriteSaga);
    yield takeLatest(REMOVE_CINEMA_FROM_FAVORITE, removeCinemaFromFavoriteSaga);
    yield takeLatest(STORE_FACEBOOK_OR_GOOGLE_RESPONSE, storeFacebookOrGoogleResponseSaga);
}


// WEBPACK FOOTER //
// ./src/SHARED/sagas/profile.saga.js